export const iconMappings = {
  FB: 'fa-brands fa-facebook',
  LN: 'fa-brands fa-linkedin-in',
  MS: 'fa-regular fa-calendar',
  SK: 'fa-brands fa-skype',
  TW: 'fa-brands fa-twitter',
  WA: 'fa-brands fa-whatsapp',
  WB: 'fa-solid fa-globe'
};

export default iconMappings;
